import { createTheme } from "@mui/material";

import palette from "./palette";
import typography from "../light-theme/typography";
import overrides from "../light-theme/overrides";

const theme = createTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

export default theme;
